const {
  AvatarOrg,
  AvatarTeam,
  AvatarUser,
  Button,
  Icon,
  Input,
  Modal,
  Spinner,
  Subhead,
  Text,
  SingleSelect,
} = window.__uniformui_Components;

export {
  AvatarOrg,
  AvatarTeam,
  AvatarUser,
  Button,
  Icon,
  Input,
  Modal,
  Spinner,
  Subhead,
  Text,
  SingleSelect,
};
